import React from "react";
import "./styles/header.css";
import LanguageTranslate from "./language/Language";
import { Theme } from "../Theme";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LoginResponse } from "../types";
import { resetLogin } from "../slices/adminLoginSlice";
import { useMsal } from "@azure/msal-react";
import LogOut from "../assets/images/icons/Logout";
// import { useSelector } from 'react-redux';

interface HeaderProps {
  role?: string;
  isNoHeaderOption?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  role,
  isNoHeaderOption = false,
}) => {
  // const roleData = useSelector((state: any) => state.roleInfo);
  const userLoginData: LoginResponse = useSelector(
    (state: any) => state.adminLogin
  );

  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch<any>();
  const feedbackID: string | null = sessionStorage.getItem("feedbackId");
  const goToHome = () => {
    navigate("/dashboard");
  };
  const buttonRole = "button";
  const childPath = feedbackID ? `/qr/${feedbackID}` : "/";

  function setTheme() {
    document.body.classList.add("theme-a");
  }
  const userLoginHeader = () => {
    if (userLoginData.isUserLoggedIn) {
      console.log("true");
    } else {
      console.log("false");
    }
  };
  const handleSignOut = () => {
    dispatch(resetLogin());
    instance.logoutRedirect({
      postLogoutRedirectUri: "/admin",
    });
  };

  return (
    <div className={`header-wrap ${role ? "no-skin" : ""}`}>
      <div className="header-container">
        <div className="flex justify-between">
          <div className="flex">
            {role ? (
              <Link to="/report-dashboard" className="logo-link">
                <strong className="text-logo">Safe2Share</strong>
              </Link>
            ) : (
              <Link to={childPath} className="logo-link">
                <strong className="text-logo">Safe2Share</strong>
              </Link>
            )}
          </div>
          {isNoHeaderOption ? (
            <>{setTheme()}</>
          ) : (
            <div className={role ? "flex items-center" : ""}>
              <div
                className={`flex ${role ? "justify-end" : "justify-between"}`}
              >
                {userLoginData.isUserLoggedIn && role ? (
                  <div className="userLoginHeader">
                    <div className="logout-block" onClick={handleSignOut}>
                      <LogOut />
                      <p>Sign out</p>
                    </div>
                    <LanguageTranslate role="commissioner" />
                  </div>
                ) : (
                  <LanguageTranslate role="commissioner" />
                )}

                {role ? (
                  ""
                ) : (
                  <button
                    onClick={goToHome}
                    className="clear-button-style p-2 pr-0"
                    role={buttonRole}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="48.512"
                      height="65.128"
                      viewBox="0 0 48.512 65.128"
                      className="max_md:w-[44px] max_md:h-[50px]"
                    >
                      <g
                        id="Group_3671"
                        data-name="Group 3671"
                        transform="translate(-940.328 -42)"
                        className="header-home-icon"
                      >
                        <g
                          id="Semibold-S"
                          transform="translate(911.235 112.735)"
                        >
                          <path
                            id="Path_14663"
                            data-name="Path 14663"
                            d="M17.061-30.735V-57.867l20-12.868,20,12.868v27.132H42.077V-46.847H32.046v16.112Z"
                            transform="translate(16)"
                          />
                        </g>
                        <path
                          id="Path_14905"
                          data-name="Path 14905"
                          d="M9.008-11.2H11.6V0H9.008ZM3.92,0H1.328V-11.2H3.92ZM9.2-4.592H3.728V-6.784H9.2ZM18.176.128a5.044,5.044,0,0,1-2.44-.576,4.385,4.385,0,0,1-1.68-1.576A4.258,4.258,0,0,1,13.44-4.3a4.288,4.288,0,0,1,.616-2.3,4.326,4.326,0,0,1,1.68-1.568,5.1,5.1,0,0,1,2.44-.568,5.114,5.114,0,0,1,2.432.568,4.273,4.273,0,0,1,1.68,1.56A4.32,4.32,0,0,1,22.9-4.3a4.3,4.3,0,0,1-.608,2.28,4.311,4.311,0,0,1-1.68,1.576A5.056,5.056,0,0,1,18.176.128Zm0-2.048a2.189,2.189,0,0,0,1.12-.288,2.051,2.051,0,0,0,.784-.824A2.651,2.651,0,0,0,20.368-4.3a2.639,2.639,0,0,0-.288-1.28A2.064,2.064,0,0,0,19.3-6.4a2.189,2.189,0,0,0-1.12-.288,2.189,2.189,0,0,0-1.12.288,2.12,2.12,0,0,0-.792.816,2.581,2.581,0,0,0-.3,1.28,2.592,2.592,0,0,0,.3,1.272,2.105,2.105,0,0,0,.792.824A2.189,2.189,0,0,0,18.176-1.92ZM35.584-8.736a3.909,3.909,0,0,1,1.816.408A2.935,2.935,0,0,1,38.648-7.08,4.486,4.486,0,0,1,39.1-4.928V0h-2.5V-4.544a2.3,2.3,0,0,0-.432-1.536,1.526,1.526,0,0,0-1.216-.5,1.925,1.925,0,0,0-.976.248,1.665,1.665,0,0,0-.672.744,2.9,2.9,0,0,0-.24,1.264V0h-2.5V-4.544a2.327,2.327,0,0,0-.424-1.536,1.5,1.5,0,0,0-1.208-.5,1.925,1.925,0,0,0-.976.248,1.665,1.665,0,0,0-.672.744,2.9,2.9,0,0,0-.24,1.264V0h-2.5V-8.608h2.384v2.352L26.5-6.944A3.083,3.083,0,0,1,27.768-8.28a3.817,3.817,0,0,1,1.88-.456,3.612,3.612,0,0,1,2.072.6A2.9,2.9,0,0,1,32.9-6.3l-.88-.24a3.446,3.446,0,0,1,1.384-1.6A4.05,4.05,0,0,1,35.584-8.736ZM45.68.128A5.542,5.542,0,0,1,43.1-.448a4.247,4.247,0,0,1-1.72-1.576,4.3,4.3,0,0,1-.608-2.28,4.375,4.375,0,0,1,.6-2.3,4.254,4.254,0,0,1,1.64-1.568,4.826,4.826,0,0,1,2.352-.568,4.81,4.81,0,0,1,2.28.536,4.013,4.013,0,0,1,1.608,1.536,4.613,4.613,0,0,1,.592,2.392q0,.144-.016.328t-.032.344H42.8V-5.056h5.68l-.96.432a2.392,2.392,0,0,0-.272-1.168,1.986,1.986,0,0,0-.752-.776,2.182,2.182,0,0,0-1.12-.28,2.226,2.226,0,0,0-1.128.28,1.956,1.956,0,0,0-.76.784,2.474,2.474,0,0,0-.272,1.192v.384a2.42,2.42,0,0,0,.312,1.24,2.036,2.036,0,0,0,.88.816,2.989,2.989,0,0,0,1.336.28,3.238,3.238,0,0,0,1.208-.208A2.942,2.942,0,0,0,47.9-2.7l1.328,1.44A3.869,3.869,0,0,1,47.744-.232,5.505,5.505,0,0,1,45.68.128Z"
                          transform="translate(939 107)"
                        />
                      </g>
                    </svg>
                  </button>
                )}
              </div>
              {role ? (
                <>{setTheme()}</>
              ) : (
                <div className="flex justify-end mt-3 max_md:mt-1">
                  <Theme />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
